import GenerateKeyModal from "./GenerateKeyModalContainer";

export default GenerateKeyModal;
